import { ScopeModel } from '../../../modules/Apps';
import { PopoverStateReturn } from '../../common/Drawer/Drawer.context';
import { ReadOnlyFormDrawer } from '../../common/ReadOnlyFormDrawer';

import { ScopesForm } from './ScopesForm';

interface ReadOnlyScopeDrawerProps {
  state: PopoverStateReturn;
  scope: ScopeModel;
}

export function ReadOnlyScopeDrawer({ scope, state }: ReadOnlyScopeDrawerProps) {
  return (
    <ReadOnlyFormDrawer
      initialValues={scope}
      title="View Scope"
      subtitle="Scope properties"
      state={state}
    >
      {() => <ScopesForm readonly />}
    </ReadOnlyFormDrawer>
  );
}
